import { render, staticRenderFns } from "./firstAidKit.vue?vue&type=template&id=2d7b743c"
import script from "./firstAidKit.vue?vue&type=script&lang=js"
export * from "./firstAidKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports